import clsx from 'clsx';
import DOMPurify from 'dompurify';
import { forwardRef } from 'react';

interface RichTextProps {
  html: string;
  className?: string;
}

export const RichText = forwardRef<HTMLDivElement, RichTextProps>(
  ({ html, className }, ref) => {
    const clean = DOMPurify.sanitize(html);

    return (
      <div
        ref={ref}
        className={clsx('prose prose-sm max-w-none', className)}
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    );
  },
);

RichText.displayName = 'RichText';
